import { IAdd } from './add-activity';
import { IAnnouncement } from '../action/announcement';

export interface IAnnouncementsProps {
    announcements?: Array<{ targets?: Array<
        {
          userType?: number;
          contextId?: string;
          contextType?: number;
        }
      >,
    content?: string;
    smsContent?: string;
    fileUploadKey?: string;
    isSms?: boolean;
    isEmail?: boolean;
    isNotification?: boolean;
    isPin?: boolean;
    isShowOnStartUp?: boolean;
    endDate?: Date;
    announcementId?: string;
    fromDisplayName?: string;
    fromAvatarPath?: string;
    subject?: string;
    body?: string;
    isRead?: boolean;
    startDate?: Date;
    totalCount?: number;
    createdDate?: Date; }>;
    coursePageClassId?: string;
    coursePageActivityId?:string;
    announcementIsLoaded?: boolean;
    dispatch?: any;
    triggerAnnouncementModal?: any;
}

export enum MessageState {
    Draft = 0,
    Sent = 1,
    Trash = 2,
    Deleted = 3,
    Inbox = 4
}

export enum SecurityContextType {
    None = 0,
    System = 1,
    Organization = 2,
    Program = 4,
    Course = 8,
    Class = 16,
    Group = 32,
    User = 64,
    Activity = 128,
    ActivityIncomplete = 129,
    MasterCourse = 256,
    Term = 512
}

export interface IAddAnnouncement extends IAdd {
    coursePageClassId?: string;
    announcementData?: IAnnouncement;
    updateAnnouncementId?: string;
    userPreferences?: Array<IPreference>;
    isModalOpen?: any;
    setCloseModal?: any;
    findDateFormat?: any;
    onTabChange?: any;
    classId? : any;
    courseId?: any;
    courseIds?: Array<string>;
}
